import { render, staticRenderFns } from "./ProfileUnsolicited.vue?vue&type=template&id=95b34db0&scoped=true"
import script from "./ProfileUnsolicited.vue?vue&type=script&lang=js"
export * from "./ProfileUnsolicited.vue?vue&type=script&lang=js"
import style0 from "./ProfileUnsolicited.vue?vue&type=style&index=0&id=95b34db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b34db0",
  null
  
)

export default component.exports